/* ============
 * Packaging Type Transformer
 * ============
 *
 * The transformer for the packagingType.
 */

import Transformer from './transformer';

export default class PackagingTypeTransformer extends Transformer {

  static fetch(packagingType) {
    return {
      id: packagingType.id,
      name: packagingType.name,
    };
  }

  static send(packagingType) {
    return {
      id: packagingType.id,
      name: packagingType.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/packagingType.js